import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import OurWork from "../components/site/OurWork";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-[var(--bg)] text-[var(--ink)] font-sans"
    >
      <Nav />
      <Hero />
      <OurWork />
    </main>
  );
}
